"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var ApiConfig_1 = require("../config/ApiConfig");
var ApiManager_1 = require("../ApiManager");
var utils_1 = require("../../utils");
var ApiPayment = /** @class */ (function (_super) {
    __extends(ApiPayment, _super);
    function ApiPayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.PRODUCT_LIST = '/api/v1/product/lists';
        _this.PAYMENT_PREPARE = '/payment/prepare';
        _this.PAYMENT_CONFIRM = '/payment/confirm';
        _this.GET_COUNT_BY_USERID = '/payment/countByUserId';
        _this.ORDER_CONFIRM_BOKU = '/orderConfirm/boku';
        _this.PAYMENT_UPDATE_ORDER_ID = '/payment/update/';
        _this.PAYMENT_PREPARE_RECURRING = '/payment/prepare/recurring';
        /**
         * payment orderid 발급
         * @param request
         * @param callback
         */
        _this.paymentPrepare = function (request, callback) {
            var data = request;
            // 결제할인 쿠폰 적용
            if (request.CouponItem) {
                // CouponItem => goods  전환 처리
                data = __assign(__assign({}, data), { goods: {
                        goodsId: request.CouponItem.goodsId.toString(),
                        goodsType: request.CouponItem.goodsType,
                    } });
            }
            // 요청 전 CouponItem 제거
            delete data.CouponItem;
            ApiConfig_1.Axios.Client({
                method: 'post',
                url: "".concat(_this.PAYMENT_PREPARE),
                responseType: 'json',
                header: {
                    // language: 'en', // TODO: 확인필요
                    token: request.accessToken,
                },
                data: data,
            })
                .then(function (result) {
                callback(result.data);
            })
                .catch(function (err) {
                callback(err);
            });
        };
        /**
         *
         * @param request
         * @param callback
         */
        _this.paymentPrepareRecurring = function (request, callback) {
            var data = request;
            // // 결제할인 쿠폰 적용
            // if (request.CouponItem) {
            //   // CouponItem => goods  전환 처리
            //   data = {
            //     ...data,
            //     goods: {
            //       goodsId: request.CouponItem.goodsId.toString(),
            //       goodsType: request.CouponItem.goodsType,
            //     },
            //   };
            // }
            // // 요청 전 CouponItem 제거
            // delete data.CouponItem;
            ApiConfig_1.Axios.Client({
                method: 'post',
                url: "".concat(_this.PAYMENT_PREPARE_RECURRING),
                responseType: 'json',
                header: {
                    'x-api-key': "".concat(process.env.REACT_APP_API_KEY),
                    // language: 'en', // TODO: 확인필요
                    token: request.accessToken,
                },
                data: data,
            })
                .then(function (result) {
                callback(result.data);
            })
                .catch(function (err) {
                callback(err);
            });
        };
        /**
         * Paypal 결제 완료 요청
         * @param request
         * @param callback
         */
        _this.paymentConfirm = function (request, callback) {
            var data = {
                pg: request.pg,
                orderId: request.orderId,
                referenceId: request.referenceId,
                userId: request.userId,
            };
            // recurring의 경우 method 추가됨
            if (utils_1.TypeCheck.itemsByPath(request, 'method')) {
                data['method'] = request['method'];
            }
            var headers = {
                // language: 'en', // TODO: 확인필요
                token: request.accessToken,
            };
            if (request.accessToken === null) {
                delete headers.token;
            }
            ApiConfig_1.Axios.Client({
                method: 'post',
                url: "".concat(_this.PAYMENT_CONFIRM),
                responseType: 'json',
                header: headers,
                data: data,
            })
                .then(function (result) {
                callback(result);
            })
                .catch(function (err) {
                callback(new Error('paypalError'));
            });
        };
        /**
         * 위쳇 요청시 payment prepare 요청
         * @param request
         * @param callback
         */
        _this.paymentPrepareFroWeChat = function (request, callback) {
            var data = request;
            // 결제할인 쿠폰 있을 경우 goods 추가
            if (request.CouponItem) {
                // CouponItem => goods  전환 처리
                data = __assign(__assign({}, data), { goods: {
                        goodsId: request.CouponItem.goodsId.toString(),
                        goodsType: request.CouponItem.goodsType,
                    } });
            }
            // wechat 무조건 소문자 지정
            data = __assign(__assign({}, data), { pg: data.pg.toLowerCase() });
            // 요청 전 CouponItem 제거
            delete data.CouponItem;
            var headers = {
                // language: 'en', // TODO: 확인필요
                token: request.accessToken,
            };
            ApiConfig_1.Axios.Client({
                method: 'post',
                url: "".concat(_this.PAYMENT_PREPARE),
                responseType: 'json',
                header: headers,
                data: data,
            })
                .then(function (result) {
                callback(result.data);
            })
                .catch(function (err) {
                callback(err);
            });
        };
        /**
         * 결제 횟수 획득
         * @param token
         */
        _this.getCountByUserId = function (token) {
            return new Promise(function (resolve, reject) {
                ApiConfig_1.Axios.Client({
                    method: 'get',
                    url: _this.GET_COUNT_BY_USERID,
                    responseType: 'json',
                    header: {
                        token: token,
                    },
                })
                    .then(function (res) {
                    resolve(res.data.data);
                })
                    .catch(function (err) {
                    reject(err);
                });
            });
        };
        /**
         * @deprecated API 확장용 (실사용 X)
         * 코인 지급 요청 복원 (Axios 샘플 참조용!!!)
         * @param result
         * @param orderId
         * @param tid
         * @param accessToken
         * @returns
         */
        // request 타입
        _this.coinInjection = function (result, orderId, tid, accessToken) { return __awaiter(_this, void 0, void 0, function () {
            var data, request;
            return __generator(this, function (_a) {
                data = {
                    result: result,
                    orderId: orderId,
                    tid: tid,
                };
                request = ApiConfig_1.Axios.Client({
                    method: 'post',
                    url: "payment/result",
                    responseType: 'json',
                    header: {
                        // language: 'en', // TODO: 확인필요
                        token: accessToken,
                    },
                    data: data,
                });
                return [2 /*return*/, request];
            });
        }); };
        /**
         * 데스크탑에서 구매확인 interval
         * @param accessToken 사용자 인증 토큰
         * @param orderId 위쳇 주문 번호
         * @returns
         */
        _this.wechatIntervalCheckForDesktop = function (accessToken, orderId) {
            var headers = {
                // language: 'en', // TODO: 확인필요
                token: accessToken,
                // Cookie: 'next-i18next=en',
                // 'Content-Type': 'application/json',
            };
            var requestBody = {
                pg: 'wechat',
                orderId: orderId,
            };
            return ApiConfig_1.Axios.Client({
                method: 'post',
                url: '/payment/intervalCheck',
                responseType: 'json',
                header: headers,
                data: requestBody,
            });
            // fetch(`${process.env.REACT_APP_BASE_URL}/payment/intervalCheck`, {
            //   method: 'POST',
            //   headers: {
            //     'x-api-key': `${process.env.REACT_APP_API_KEY}`,
            //     language: 'en',
            //     token: accessToken,
            //     Cookie: 'next-i18next=en',
            //     'Content-Type': 'application/json',
            //   },
            //   body: JSON.stringify({
            //     pg: 'wechat',
            //     orderId,
            //   }),
            // });
        };
        /**
         * 결제 정보 업데이트
         * @param orderId paypal value
         * @returns
         */
        _this.paymentUpdateOrderId = function (orderId, papalValue, accessToken) {
            var headers = {
                // language: 'en', // TODO: 확인필요
                token: accessToken,
            };
            var requestBody = {
                params: {
                    tId: papalValue,
                },
            };
            return ApiConfig_1.Axios.Client({
                method: 'post',
                url: "".concat(_this.PAYMENT_UPDATE_ORDER_ID).concat(orderId),
                responseType: 'json',
                header: headers,
                data: requestBody,
            });
        };
        return _this;
        // TODO: 사용안함 확장을 위해 남겨둠
        // useProductId = async (productId, accessToken, callback) => {
        //   const PRODUCT_ID = '/api/v1/product';
        //   try {
        //     const response = await axios.request({
        //       method: 'get',
        //       url: `${PRODUCT_ID}/${productId}`,
        //       responseType: 'json',
        //       headers: {
        //         'x-api-key': `${process.env.REACT_APP_API_KEY}`,
        //         language: 'en',
        //         token: accessToken,
        //       },
        //     });
        //     callback(response.data);
        //   } catch (error) {
        //     callback(error);
        //   }
        // };
        // TODO: 사용안함 확장을 위해 남겨둠
        // getProductId = createAsyncThunk(
        //   PRODUCT_ID,
        //   async (request: APIProductRequest, thunkAPI) => {
        //     try {
        //       const response = await axios.request({
        //         method: 'get',
        //         url: `${PRODUCT_ID}/${request.productId}`,
        //         responseType: 'json',
        //         headers: {
        //           token: request.accessToken,
        //           language: 'en',
        //         },
        //       });
        //       return response.data;
        //     } catch (error) {
        //       thunkAPI.rejectWithValue(error.response.data);
        //     }
        //   },
        // );
    }
    ApiPayment.getInstance = function (initValue) {
        if (!ApiPayment.classInstance) {
            this.classInstance = new ApiPayment(initValue);
        }
        return this.classInstance;
    };
    ApiPayment.prototype.orderConfirmBoku = function (request) {
        return ApiConfig_1.Axios.Client({
            method: 'post',
            url: "".concat(this.ORDER_CONFIRM_BOKU),
            header: {
                token: request.accessToken,
                // language: 'en', // TODO: 확인필요
            },
            responseType: 'json',
            data: request,
        });
    };
    ApiPayment.prototype.getProducts = function (accessToken) {
        var source = axios_1.default.CancelToken.source();
        var request = ApiConfig_1.Axios.Client({
            method: 'get',
            url: "".concat(this.PRODUCT_LIST),
            responseType: 'json',
            header: {
                token: accessToken,
                // language: 'en', // TODO: 확인필요
            },
            cancelToken: source.token,
        });
        var result = {
            request: request,
            cancel: source,
        };
        return result;
    };
    return ApiPayment;
}(ApiManager_1.ApiManager));
exports.default = ApiPayment;
